// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeaveModal_backdrop__kImzR {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(16, 24, 40, 0.1215686275);
  padding: 22px;
}

.LeaveModal_modal__HhDQe {
  position: relative;
  width: 570px;
  max-width: 95%;
  background: #fff9f8;
  border-radius: 12px;
  padding: 36px 32px;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.1215686275);
  text-align: center;
  -webkit-font-smoothing: antialiased;
}

.LeaveModal_closeBtn__EJYj5 {
  position: absolute !important;
  top: 12px;
  right: 12px;
  width: 44px !important;
  height: 44px !important;
  min-width: 0 !important;
  border-radius: 50% !important;
  background: var(--white) !important;
  box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  cursor: pointer;
  border: none !important;
}
.LeaveModal_closeBtn__EJYj5 img {
  width: 20px !important;
}

.LeaveModal_iconCircle__qoFt\\+ {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #fff0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 18px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}
.LeaveModal_iconCircle__qoFt\\+ img {
  width: 32px;
  height: 32px;
}

.LeaveModal_title__VH0g6 {
  font: var(--h3);
  font-family: var(--font-bodoni-72);
  font-weight: 700;
  font-size: 32px;
  line-height: 38.4px;
  color: #222222;
  margin: 6px 0 4px;
  text-transform: none;
}

.LeaveModal_subtitle__pZzVo {
  font-size: 14px;
  color: var(--secondary-Text);
  margin: 8px 0 20px;
}

.LeaveModal_footer__eoLVq {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
}

@media screen and (max-width: 767px) {
  .LeaveModal_modal__HhDQe {
    padding: 20px 16px;
  }
  .LeaveModal_closeBtn__EJYj5 {
    width: 30px !important;
    height: 30px !important;
    top: 10px;
    right: 10px;
  }
  .LeaveModal_iconCircle__qoFt\\+ {
    width: 56px;
    height: 56px;
    margin-bottom: 14px;
  }
  .LeaveModal_title__VH0g6 {
    font-size: 20px;
  }
  .LeaveModal_subtitle__pZzVo {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/modal/LeaveModal.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;EACA,aAAA;AACD;;AAEA;EACC,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sDAAA;EACA,kBAAA;EACA,mCAAA;AACD;;AAEA;EACC,6BAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,wDAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AACD;AACC;EACC,sBAAA;AACF;;AAGA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kDAAA;AAAD;AAEC;EACC,WAAA;EACA,YAAA;AAAF;;AAIA;EACC,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AADD;;AAIA;EACC,eAAA;EACA,4BAAA;EACA,kBAAA;AADD;;AAIA;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AADD;;AAIA;EACC;IACC,kBAAA;EADA;EAID;IACC,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;EAFA;EAKD;IACC,WAAA;IACA,YAAA;IACA,mBAAA;EAHA;EAMD;IACC,eAAA;EAJA;EAOD;IACC,eAAA;EALA;AACF","sourcesContent":[".backdrop {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tbackground-color: #1018281f;\r\n\tpadding: 22px;\r\n}\r\n\r\n.modal {\r\n\tposition: relative;\r\n\twidth: 570px;\r\n\tmax-width: 95%;\r\n\tbackground: #fff9f8;\r\n\tborder-radius: 12px;\r\n\tpadding: 36px 32px;\r\n\tbox-shadow: 0 20px 40px #0f172a1f;\r\n\ttext-align: center;\r\n\t-webkit-font-smoothing: antialiased;\r\n}\r\n\r\n.closeBtn {\r\n\tposition: absolute !important;\r\n\ttop: 12px;\r\n\tright: 12px;\r\n\twidth: 44px !important;\r\n\theight: 44px !important;\r\n\tmin-width: 0 !important;\r\n\tborder-radius: 50% !important;\r\n\tbackground: var(--white) !important;\r\n\tbox-shadow: 0 6px 18px rgba(17, 24, 39, 0.06) !important;\r\n\tdisplay: flex !important;\r\n\talign-items: center !important;\r\n\tjustify-content: center !important;\r\n\tpadding: 0 !important;\r\n\tcursor: pointer;\r\n\tborder: none !important;\r\n\r\n\timg {\r\n\t\twidth: 20px !important;\r\n\t}\r\n}\r\n\r\n.iconCircle {\r\n\twidth: 56px;\r\n\theight: 56px;\r\n\tborder-radius: 50%;\r\n\tbackground: #fff0f0;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tmargin: 0 auto 18px;\r\n\tbox-shadow: inset 0 1px 0 #ffffff99;\r\n\r\n\timg {\r\n\t\twidth: 32px;\r\n\t\theight: 32px;\r\n\t}\r\n}\r\n\r\n.title {\r\n\tfont: var(--h3);\r\n\tfont-family: var(--font-bodoni-72);\r\n\tfont-weight: 700;\r\n\tfont-size: 32px;\r\n\tline-height: 38.4px;\r\n\tcolor: #222222;\r\n\tmargin: 6px 0 4px;\r\n\ttext-transform: none;\r\n}\r\n\r\n.subtitle {\r\n\tfont-size: 14px;\r\n\tcolor: var(--secondary-Text);\r\n\tmargin: 8px 0 20px;\r\n}\r\n\r\n.footer {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tgap: 12px;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n\t.modal {\r\n\t\tpadding: 20px 16px;\r\n\t}\r\n\r\n\t.closeBtn {\r\n\t\twidth: 30px !important;\r\n\t\theight: 30px !important;\r\n\t\ttop: 10px;\r\n\t\tright: 10px;\r\n\t}\r\n\r\n\t.iconCircle {\r\n\t\twidth: 56px;\r\n\t\theight: 56px;\r\n\t\tmargin-bottom: 14px;\r\n\t}\r\n\r\n\t.title {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\r\n\t.subtitle {\r\n\t\tfont-size: 13px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `LeaveModal_backdrop__kImzR`,
	"modal": `LeaveModal_modal__HhDQe`,
	"closeBtn": `LeaveModal_closeBtn__EJYj5`,
	"iconCircle": `LeaveModal_iconCircle__qoFt+`,
	"title": `LeaveModal_title__VH0g6`,
	"subtitle": `LeaveModal_subtitle__pZzVo`,
	"footer": `LeaveModal_footer__eoLVq`
};
export default ___CSS_LOADER_EXPORT___;
